import React from 'react'
import { Helmet } from 'react-helmet'
import { useLocation } from 'react-router-dom'

import Paths from '../utils/paths'

export default function MetaTags (props) {
  const location = useLocation()

  switch (location.pathname) {
    case Paths.BENEFITS:
      return (
        <Helmet>
          <title>Financial Wellness Benefits for Employees | Multikrd</title>
          <meta
            name='description'
            content='Enhance your employee&#39;s financial wellness with our comprehensive benefits program. Multikrd offers a range of financial wellness employee benefits to support your staff. Contact us today!'
          />
        </Helmet>
      )
    case Paths.EMPLOYEES:
      return (
        <Helmet>
          <title>Employee Financial Wellness, Engagement &amp; Experience Programs</title>
          <meta
            name='description'
            content='Boost employee satisfaction and financial well-being with Multikrd&#39;s Employee Financial Wellness Program, cashback, discounts, on-demand tips and wages, and a secured credit card for employees. Enhance employee engagement and recognition with our Employee Engagement and Experience Program. Contact us today!'
          />
        </Helmet>
      )
    case Paths.HOW_IT_WORKS:
      return (
        <Helmet>
          <title>
            HR Perks Program | Payroll HR Solutions | Pay On Demand Service - Multikrd
          </title>
          <meta
            name='description'
            content='Revolutionize your payroll with Multikrd&#39;s Pay On Demand Service, Payroll Direct Deposit, and Payroll Paycard options. Streamline your payroll system with our PEO, HR and Payroll seamless integrations. Visit our website today!'
          />
        </Helmet>
      )
    case Paths.PREPAID_CARDS:
      return (
        <Helmet>
          <title>
            Prepaid Cards
          </title>
          <meta
            name='description'
            content='Help your employees build credit with Multikrd&#39;s Credit Building Solution A Secured Credit Card that boosts financial health. Improve financial well-being and offer a valuable perk to your staff. Visit our webiste today!'
          />
        </Helmet>
      )
    case Paths.DISCOUNTS:
      return (
        <Helmet>
          <title>
            Discounts and Perk Program for Employees
          </title>
          <meta
            name='description'
            content='Offer valuable discounts to your employees with Multikrd&#39;s holistic platform, which includes over 1.5 million saving opportunities for your employees.. Enhance employee satisfaction and save them money with our wide range of discount options. Contact us today!'
          />
        </Helmet>
      )
    case Paths.TIPS:
      return (
        <Helmet>
          <title>
            Easily Manage, distribute, and administer tips to your employees the same day they work.
          </title>
          <meta
            name='description'
            content='Automate your tips management process with Multikrd&#39;s Tips On-Demand Our system streamlines tips disbursement and enables daily tips payments for your staff. Visit our website today to learn more!'
          />
        </Helmet>
      )
    case Paths.WAGE_ACCESS:
      return (
        <Helmet>
          <title>
            Best Earned Wage Access Apps and web platforms
          </title>
          <meta
            name='description'
            content='Get paid when needed with Multikrd&#39;s Earned Wage Access and Early Wage Access options. Say goodbye to waiting for payday and improve financial flexibility. Contact us today to learn more!'
          />
        </Helmet>
      )
    case Paths.EMPLOYEES:
      return (
        <Helmet>
          <title>
            White Label Perks Program for Employees
          </title>
          <meta
            name='description'
            content='Using our modular design, employers can fully customize their platform’s look, feel and functionality. Multikrd helps you offer at no cost a valuable platform for your employees that helps boost financial health.'
          />
        </Helmet>
      )
    case Paths.CASHBACK:
      return (
        <Helmet>
          <title>
            Free Rewards for Employees &amp; Programs
          </title>
          <meta
            name='description'
            content='Boost employee engagement and satisfaction with Multikrd Rewards Program for employees. We offer free rewards and perks for your staff to show your appreciation. Visit us today to learn more!'
          />
        </Helmet>
      )
    case location.pathname === Paths.BLOG ? location.pathname : null:
      return (
        <Helmet>
          <title>
            Employee Recognition, Success Talent Attraction & Retention Program | Multikrd
          </title>
          <meta
            name='description'
            content='Boost employee morale with our Staff Recognition Program & Employee Success Program. Same day pay & paycheck advance options are available for talent attraction and retention. Visit Now!'
          />
        </Helmet>
      )
    case location.pathname.startsWith(Paths.BLOG) ? location.pathname : null:
      return (
        <Helmet>
          <title>
            {location.state?.title}
          </title>
          <meta
            name='description'
            content={location.state?.resume}
          />
        </Helmet>
      )
    default:
      return (
        <Helmet>
          <title>
            Employee Recognition, Success Talent Attraction & Retention Program | Multikrd
          </title>
          <meta
            name='description'
            content='Boost employee morale with our Staff Recognition Program & Employee Success Program. Same day pay & paycheck advance options are available for talent attraction and retention. Visit Now!'
          />
        </Helmet>
      )
  }
}
